import { Header } from "semantic-ui-react";
import React from "react";

export const PendencyEmployee = ({ employee }) => {
  return (
    <Header size={"tiny"}>
      {employee.name}
      <Header.Subheader>
        {employee?.email || employee.employee_code}
      </Header.Subheader>
    </Header>
  );
};
